export enum TOOLTIP_DIRECTION {
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'top',
  DOWN = 'bottom',
}